import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/motivo-de-movimiento-de-empleado';

/**
 * Get Motivos De Movimientos De Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getMotivosDeMovimientosDeEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Motivo De Movimiento De Empleado
 * @params {number} id
 * @returns {Promise<object|null>};
 */
export const getMotivoDeMovimientoDeEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Motivo De Movimiento De Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postMotivoDeMovimientoDeEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Motivo De Movimiento De Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMotivoDeMovimientoDeEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Motivo De Movimiento De Empleado
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteMotivoDeMovimientoDeEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
